// import authSlice from 'containers/Authorization/auth.slice';
import authSlice from 'containers/Login/auth.slice';
import categorySlice from 'containers/QuestionCategory/category.slice';
import questionSlice from 'containers/Questions/question.slice';
import acountsSlice from 'containers/AccountSettings/accounts.slice';
import reportSlice from 'containers/Reports/report.slice';
import managequesSlice from 'containers/ManageQuestions/manageques.slice';

const rootReducer = {
  auth: authSlice,
  category: categorySlice,
  question: questionSlice,
  accounts: acountsSlice,
  reports: reportSlice,
  manageques: managequesSlice
};

export default rootReducer;
